var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footerContain"},[_c('div',{staticClass:"pOne"},[_vm._v(" Copyright(c) 匠芯株式会社 "),_c('span',[_vm._v("2023 Co.,Ltd. All rights Reserved.| ")]),_c('span',{staticClass:"cursor",on:{"click":_vm.goPolicy}},[_vm._v(" 個人情報保護方針 |")]),_c('span',{staticClass:"cursor",on:{"click":_vm.goAccess}},[_vm._v(" お問い合せ ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }